const ServiceValues = {
  base_url_local: process.env.REACT_APP_API_URL || 'http://clubedetirogaranhuns.com:5892/',
  timeout: 20000,
};

export {ServiceValues};
